import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimNormalContractResultData } from 'gql/graphql';

import type React from 'react';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimNormalContractResultsGql } from '../BimContractRequests';

const requestId = 'bimNormalContractResults';

export const useBimNormalContractResults = (
    contractId: number,
    setNormalContractResults: React.Dispatch<
        React.SetStateAction<(BimNormalContractResultData | null)[] | undefined | null>
    >,
) => {
    const dispatch = useDispatch();

    const [bimNormalContractResultsData, bimNormalContractResultsStatus, , bimNormalContractResultsMakeRequest] =
        useRequest({
            requestId,
            query: bimNormalContractResultsGql,
            withEffect: false,
        });

    const [bimNormalContractResultsMakeReset] = useResetStoreData({ requestId });

    const bimNormalContractResultsRequest = useCallback(() => {
        bimNormalContractResultsMakeReset(undefined);

        dispatch(bimNormalContractResultsMakeRequest({ contractId }));
    }, [bimNormalContractResultsMakeRequest, bimNormalContractResultsMakeReset, contractId, dispatch]);

    useEffect(() => {
        if (bimNormalContractResultsData?.bimNormalContractResults?.result === true) {
            setNormalContractResults(bimNormalContractResultsData?.bimNormalContractResults?.data);
        }
    }, [
        bimNormalContractResultsData?.bimNormalContractResults?.data,
        bimNormalContractResultsData?.bimNormalContractResults?.result,
        setNormalContractResults,
    ]);

    useEffect(() => {
        bimNormalContractResultsMakeReset(undefined);
    }, [bimNormalContractResultsMakeReset]);

    return {
        bimNormalContractResultsStatus,
        bimNormalContractResultsRequest,
    };
};
